import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useGlobalState from 'utils/global-state';

export const GDPR_PATH = '/gdpr';

const PrivateRoute = ({
  path, component, redirect = null, routeGuard = null, skipGdprCheck = false,
}) => {
  const [{ userData }] = useGlobalState();

  if (!userData || (routeGuard && !routeGuard(userData))) {
    return <Redirect to={redirect ?? '/'} />;
  }

  if (!skipGdprCheck && userData.isGdprConfirmed !== true) {
    return <Redirect to={GDPR_PATH} />;
  }

  return <Route path={path} component={component} />;
};

export default PrivateRoute;
